<template>
  <div>
    <div
      v-for="s in children"
      :key="s.key"
    >
      <div class="text-left d-flex">
        <div
          v-if="hasChildren(s.key)"
          class="caret hover"
          @click="$set(expanded, s.key, !expanded[s.key])"
        >
          <i
            class="far"
            :class="expanded[s.key] ? 'fa-caret-down' : 'fa-caret-right'"
          />
        </div>
        <div
          v-else
          class="caret"
        />
        <div
          class="sort-option d-flex flex-grow-1 align-items-center"
          @click.stop="toggleSelection(s.key)"
        >
          <BFormCheckbox
            :checked="isSelected(s.key)"
            @change="toggleSelection(s.key)"
          />
          <div
            class="flex-grow-1"
            @click.stop="toggleSelection(s.key)"
          >
            {{ s.text }}
          </div>
          <button
            v-if="hasChildren(s.key)"
            class="select-all-btn"
            @click.stop="toggleAllDescendants(s.key)"
          >
            {{ areAllDescendantsSelected(s.key) ? 'Odznacz wszystkie' : 'Zaznacz wszystkie' }}
          </button>
        </div>
      </div>

      <GroupMultiSelect
        v-if="s.key !== '#all' && (expand || expanded[s.key])"
        class="ml-3"
        :groups="groups"
        :selected="selected"
        :root-id="s.key"
        :expand="expand"
        @toggle="$emit('toggle', $event)"
        @toggle-batch="(...args) => $emit('toggle-batch', ...args)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupMultiSelect',
  props: {
    groups: Array,
    selected: Array,
    rootId: String,
    expand: Boolean,
  },
  data: () => ({
    expanded: {},
  }),
  computed: {
    children() {
      return this.groups.filter((x) => x.parentCode === this.rootId);
    },
  },
  methods: {
    hasChildren(parentCode) {
      return parentCode !== '#all' && this.groups.some((x) => x.parentCode === parentCode);
    },
    isSelected(code) {
      return this.selected && this.selected.includes(code);
    },
    toggleSelection(code) {
      this.$emit('toggle', code);
    },
    getAllDescendants(parentCode) {
      // Only get direct children, not all descendants
      return this.groups.filter((x) => x.parentCode === parentCode).map((x) => x.code);
    },
    areAllDescendantsSelected(parentCode) {
      const descendants = this.getAllDescendants(parentCode);
      return descendants.length > 0 && descendants.every((code) => this.isSelected(code));
    },
    toggleAllDescendants(parentCode) {
      const descendants = this.getAllDescendants(parentCode);
      const allSelected = this.areAllDescendantsSelected(parentCode);

      // Emit all codes at once to avoid race conditions
      this.$emit('toggle-batch', descendants, !allSelected);
    },
  },
};
</script>

<style lang="scss" scoped>
.caret {
  width: 25px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #efefef;

  &.hover {
    cursor: pointer;

    &:hover {
      background-color: #ddd;
    }
  }
}

.sort-option {
  cursor: pointer;
  padding: 8px 12px;
  border-top: 1px solid #efefef;

  &:hover {
    background-color: #f5f5f5;
  }
}

.checkbox-wrapper {
  margin-right: 8px;
  cursor: pointer;
}

.select-all-btn {
  background-color: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 8px;

  &:hover {
    background-color: #f0f0f0;
    border-color: #999;
  }

  &:active {
    background-color: #e0e0e0;
  }
}
</style>
